export const ROLES = {
  DEMO_USER: "DEMO_USER",
  CUSTOMER_USER: "CUSTOMER_USER",
  CUSTOMER_ADMIN: "CUSTOMER_ADMIN",
  FENTASAFE_ADMIN: "FENTASAFE_ADMIN",
};